export class CompanyContractAddendum {
    public id:number|null;
    public company_id:number;
    public contract_id:number;
    public document_number:number;
    public addendum_period:number;
    public date_signed:Date|null;
    public renewal:number|null;
    public file_name:string|null;
    public fuel_clause:boolean;
    public salary_clause:boolean;
    public modified_contract_clause:boolean;
    public right_of_retention:boolean;
    public right_of_pledge:boolean;
    public revoked:boolean;
    public revoked_by_user_id:number|null;
    public addendum_type:number|null;
    public description:string|null;
    public file_content_base64:string|null;


    constructor(data:CompanyContractAddendumData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.company_id = 0;
            this.contract_id = 0;
            this.document_number = 0;
            this.addendum_period = 0;
            this.date_signed = null;
            this.renewal = null;
            this.file_name = null;
            this.fuel_clause = false;
            this.salary_clause = false;
            this.modified_contract_clause = false;
            this.right_of_retention = false;
            this.right_of_pledge = false;
            this.revoked = false;
            this.revoked_by_user_id = null;
            this.addendum_type = null;
            this.description = null;
            this.file_content_base64 = null;
        }
        else
        {
            this.id = data.id;
            this.company_id = data.company_id;
            this.contract_id = data.contract_id;
            this.document_number = data.document_number;
            this.addendum_period = data.addendum_period;
            this.date_signed = null;
            if(data.date_signed !== null)
            {
                this.date_signed = new Date(data.date_signed);
            }
            this.renewal = data.renewal;
            this.file_name = data.file_name;
            this.fuel_clause = data.fuel_clause || false;
            this.salary_clause = data.salary_clause || false;
            this.modified_contract_clause = data.modified_contract_clause || false;
            this.right_of_retention = data.right_of_retention || false;
            this.right_of_pledge = data.right_of_pledge || false;
            this.revoked = data.revoked || false;
            this.revoked_by_user_id = data.revoked_by_user_id;
            this.addendum_type = data.addendum_type || null;
            this.description = data.description || null;
            this.file_content_base64 = data.file_content_base64 || null;
        }
    }

    serializeData():CompanyContractAddendumData {
        return {
            id: this.id,
            company_id: this.company_id,
            contract_id: this.contract_id,
            document_number: this.document_number,
            addendum_period: this.addendum_period,
            date_signed : this.date_signed,
            renewal: this.renewal,
            file_name: this.file_name,
            fuel_clause: this.fuel_clause,
            salary_clause: this.salary_clause,
            modified_contract_clause: this.modified_contract_clause,
            right_of_retention: this.right_of_retention,
            right_of_pledge: this.right_of_pledge,
            revoked: this.revoked,
            revoked_by_user_id: this.revoked_by_user_id,
            addendum_type: this.addendum_type,
            description: this.description,
            file_content_base64: this.file_content_base64
        }
    }


    public resetToDefaults():void {
        this.id = null;
        this.company_id = 0;
        this.contract_id = 0;
        this.document_number = 0;
        this.addendum_period = 0;
        this.date_signed = null;
        this.renewal = null;
        this.file_name = null;
        this.fuel_clause = false;
        this.salary_clause = false;
        this.modified_contract_clause = false;
        this.right_of_retention = false;
        this.right_of_pledge = false;
        this.revoked = false;
        this.revoked_by_user_id = null;
        this.addendum_type = null;
        this.description = null;
        this.file_content_base64 = null;
    }
}

export type CompanyContractAddendumData = {
    id:number|null;
    company_id:number;
    contract_id:number;
    document_number:number;
    addendum_period:number;
    date_signed:Date|null;
    renewal:number|null;
    file_name:string|null;
    fuel_clause?:boolean;
    salary_clause?:boolean;
    modified_contract_clause?:boolean;
    right_of_retention?:boolean;
    right_of_pledge?:boolean;
    revoked?:boolean;
    revoked_by_user_id:number|null;
    addendum_type:number|null;
    description?:string|null;
    file_content_base64?:string|null;
}
